import {
  GET_HOLIDAYS,
  GET_HOLIDAYS_SUCCESS,
  GET_HOLIDAYS_FAIL,
  ADD_HOLIDAY,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_FAIL,
  UPDATE_HOLIDAY,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAIL,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAIL,
  SET_HOLIDAY_FIELD_ERRORS,
} from './actionTypes'

// Get Holidays
export const getHolidays = () => ({ type: GET_HOLIDAYS })
export const getHolidaysSuccess = (holidays) => ({ type: GET_HOLIDAYS_SUCCESS, payload: holidays })
export const getHolidaysFail = (error) => ({ type: GET_HOLIDAYS_FAIL, payload: error })

// Add Holiday
export const addHoliday = (holiday) => ({ type: ADD_HOLIDAY, payload: holiday })
export const addHolidaySuccess = (holiday) => ({ type: ADD_HOLIDAY_SUCCESS, payload: holiday })
export const addHolidayFail = (error) => ({ type: ADD_HOLIDAY_FAIL, payload: error })

// Update Holiday
export const updateHoliday = (holiday) => ({ type: UPDATE_HOLIDAY, payload: holiday })
export const updateHolidaySuccess = (holiday) => ({ type: UPDATE_HOLIDAY_SUCCESS, payload: holiday })
export const updateHolidayFail = (error) => ({ type: UPDATE_HOLIDAY_FAIL, payload: error })

// Delete Holiday
export const deleteHoliday = (id) => ({ type: DELETE_HOLIDAY, payload: id })
export const deleteHolidaySuccess = (id) => ({ type: DELETE_HOLIDAY_SUCCESS, payload: id })
export const deleteHolidayFail = (error) => ({ type: DELETE_HOLIDAY_FAIL, payload: error })

// Set Field Errors
export const setHolidayFieldErrors = (errors) => ({ type: SET_HOLIDAY_FIELD_ERRORS, payload: errors })
